<div class="profile-page">
    <div class="container">
        <div class="profile-container">
            <!-- Header Section -->
            <div class="profile-header">
                <div class="header-content">
                    <i class="fa fa-user-circle header-icon" [ngStyle]="clientConfig.style.color" aria-hidden="true"></i>
                    <h1 class="profile-title" [ngStyle]="clientConfig.style.color">My Account</h1>
                    <p class="profile-subtitle">Manage your profile and account settings</p>
                </div>
            </div>

            <!-- Tab Navigation -->
            <div class="tab-navigation" role="tablist" aria-label="Account Settings Tabs">
                <button class="tab-btn" role="tab" [attr.aria-selected]="selectedTab === 1"
                    id="tab-profile" aria-controls="panel-profile"
                    [class.active]="selectedTab === 1"
                    [ngStyle]="selectedTab === 1 ? clientConfig.style.bg : {}"
                    (click)="selectedTab = 1">
                    <i class="fa fa-user" aria-hidden="true"></i>
                    <span>Profile Information</span>
                </button>
                <button class="tab-btn" role="tab" [attr.aria-selected]="selectedTab === 2"
                    id="tab-delete" aria-controls="panel-delete"
                    [class.active]="selectedTab === 2"
                    [ngStyle]="selectedTab === 2 ? clientConfig.style.bg : {}"
                    (click)="selectedTab = 2">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                    <span>Delete Account</span>
                </button>
            </div>

            <!-- Profile Form Tab -->
            <div class="tab-content" id="panel-profile" role="tabpanel" aria-labelledby="tab-profile" *ngIf="selectedTab === 1">
                <div class="content-card">
                    <div class="card-header">
                        <i class="fa fa-id-card" aria-hidden="true"></i>
                        <h2 class="h3">Personal Information</h2>
                        <p>Update your personal details below</p>
                    </div>

                    <form [formGroup]="profileForm" (ngSubmit)="updateProfile()" class="modern-form">
                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label" for="profileName">
                                    <i class="fa fa-user label-icon" aria-hidden="true"></i>
                                    Full Name
                                </label>
                                <div class="input-wrapper">
                                    <input type="text" id="profileName" formControlName="name" class="form-control-modern"
                                        [ngClass]="{'is-invalid': formErrors.name}" placeholder="Enter your full name"
                                        maxlength="50" autocomplete="name" aria-required="true"
                                        [attr.aria-invalid]="fc.name.invalid && fc.name.touched"
                                        [attr.aria-describedby]="fc.name.errors ? 'profileNameError' : null">
                                    <div *ngIf="fc.name.errors" id="profileNameError" class="error-message" role="alert">
                                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                        <span *ngIf="fc.name.errors.required">Please enter your name</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label" for="profileMobile">
                                    <i class="fa fa-phone label-icon" aria-hidden="true"></i>
                                    Mobile Number
                                </label>
                                <div class="input-wrapper">
                                    <input type="tel" id="profileMobile" numberOnly formControlName="mobile" class="form-control-modern"
                                        [ngClass]="{'is-invalid': formErrors.mobile}" placeholder="Enter mobile number"
                                        maxlength="10" autocomplete="tel" aria-required="true"
                                        [attr.aria-invalid]="fc.mobile.invalid && fc.mobile.touched"
                                        [attr.aria-describedby]="fc.mobile.errors ? 'profileMobileError' : null">
                                    <div *ngIf="fc.mobile.errors" id="profileMobileError" class="error-message" role="alert">
                                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                        <span *ngIf="fc.mobile.errors.required">Please enter your mobile number</span>
                                        <span *ngIf="fc.mobile.errors.minlength || fc.mobile.errors.maxlength">Mobile must be 10 digits</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label" for="profileEmail">
                                    <i class="fa fa-envelope label-icon" aria-hidden="true"></i>
                                    Email Address
                                </label>
                                <div class="input-wrapper">
                                    <input type="email" id="profileEmail" formControlName="email" class="form-control-modern"
                                        [ngClass]="{'is-invalid': formErrors.email}" placeholder="Enter email address"
                                        maxlength="50" autocomplete="email" aria-required="true"
                                        [attr.aria-invalid]="fc.email.invalid && fc.email.touched"
                                        [attr.aria-describedby]="fc.email.errors ? 'profileEmailError' : null">
                                    <div *ngIf="fc.email.errors" id="profileEmailError" class="error-message" role="alert">
                                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                        <span *ngIf="fc.email.errors.required">Please enter your email address</span>
                                        <span *ngIf="fc.email.errors.email">Please enter a valid email</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-actions">
                            <button type="submit" [disabled]="!profileForm.valid" [ngStyle]="clientConfig.style.bg"
                                class="btn-submit">
                                <i class="fa fa-save" aria-hidden="true"></i>
                                Update Profile
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Delete Account Tab -->
            <div class="tab-content" id="panel-delete" role="tabpanel" aria-labelledby="tab-delete" *ngIf="selectedTab === 2">
                <div class="content-card delete-account-card">
                    <div class="card-header danger-header">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        <h2 class="h3">Delete Account</h2>
                        <p>This action is permanent and cannot be undone</p>
                    </div>

                    <form [formGroup]="suspendForm" (ngSubmit)="deleteProfile()" class="modern-form">
                        <div class="warning-box">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            <div>
                                <strong>Warning:</strong> Deleting your account will remove all your data, order history, and saved preferences permanently.
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label" for="suspendPassword">
                                    <i class="fa fa-lock label-icon" aria-hidden="true"></i>
                                    Current Password
                                </label>
                                <div class="input-wrapper">
                                    <input type="password" id="suspendPassword" formControlName="password" class="form-control-modern"
                                        [ngClass]="{'is-invalid': formErrors.password}"
                                        placeholder="Enter your current password" maxlength="30"
                                        autocomplete="current-password" aria-required="true"
                                        [attr.aria-invalid]="fcs.password.invalid && fcs.password.touched"
                                        [attr.aria-describedby]="fcs.password.errors ? 'suspendPasswordError' : null">
                                    <div *ngIf="fcs.password.errors" id="suspendPasswordError" class="error-message" role="alert">
                                        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                        <span *ngIf="fcs.password.errors.required">Please enter your current password</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group-modern">
                                <label class="form-label" for="suspendDescription">
                                    <i class="fa fa-comment label-icon" aria-hidden="true"></i>
                                    Reason (Optional)
                                </label>
                                <div class="input-wrapper">
                                    <textarea id="suspendDescription" formControlName="description" class="form-control-modern textarea"
                                        [ngClass]="{'is-invalid': formErrors.description}"
                                        placeholder="Let us know why you're leaving (optional)" maxlength="50"
                                        rows="4"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="checkbox-wrapper">
                                <input type="checkbox" id="suspendConfirm" formControlName="confirm" class="checkbox-input">
                                <label class="checkbox-label" for="suspendConfirm">
                                    <span class="checkbox-custom"></span>
                                    <span class="checkbox-text">
                                        I agree to accept your
                                        <a target="_blank" rel="noopener noreferrer" routerLink="/home/tc" class="link" aria-label="terms and conditions (opens in a new window)">terms and conditions</a>
                                    </span>
                                </label>
                            </div>
                        </div>

                        <div class="form-actions">
                            <button type="submit" [disabled]="!suspendForm.valid" [ngStyle]="clientConfig.style.bg"
                                class="btn-submit btn-danger">
                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                Delete My Account
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>